const columns = [
    {
        title: 'Wallet Account No.',
        dataIndex: 'walletAccountNo',
    },
    {
        title: 'Deposit Type',
        dataIndex: 'depositType',
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
    },
    {
        title: 'Balance',
        dataIndex: 'balance',
    },
    {
        title: 'Request Date',
        dataIndex: 'requestDate',
        sorter: true,
    },
    {
        title: 'Action Date',
        dataIndex: 'actionDate',
        sorter: true,
    },
    {
        title: 'Status',
        dataIndex: 'status',
    },
    {
        title: 'Actions',
        dataIndex: 'actions',
    },
];

export default columns;
